import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Total_UnitPrices_And_Commissions_In_All_Months_Action } from '../Redux/Actions/Accountant_Action';
import { Bar } from 'react-chartjs-2';
import 'chart.js/auto';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { Link } from 'react-router-dom';

export const SalesMonyinMonthReportForAccountantPage = () => {
  const dispatch = useDispatch();
  const [chartReady, setChartReady] = useState(false);

  useEffect(() => {
    const getalldata = async () => {
      await dispatch(Total_UnitPrices_And_Commissions_In_All_Months_Action());
      setChartReady(true);
    };
    getalldata();
  }, [dispatch]);

  const resalldata = useSelector(
    (state) => state.AllAcountant_Reducer.ToalUnitPrices_AndCommission,
  );
  let AllData_Array = Array.isArray(resalldata?.data) ? resalldata.data : [];

  const topSalesMonth = AllData_Array.reduce(
    (prev, current) => (current.totalUnitPrice > prev.totalUnitPrice ? current : prev),
    { totalUnitPrice: 0 },
  );

  const topCommissionMonth = AllData_Array.reduce(
    (prev, current) => (current.totalCommission > prev.totalCommission ? current : prev),
    { totalCommission: 0 },
  );

  const chartData = {
    labels: AllData_Array.map((item) => item.month),
    datasets: [
      {
        label: 'Total Unit Price (Sales)',
        data: AllData_Array.map((item) => item.totalUnitPrice),
        backgroundColor: 'rgba(75, 192, 192, 0.7)',
      },
      {
        label: 'Total Commission',
        data: AllData_Array.map((item) => item.totalCommission),
        backgroundColor: 'rgba(255, 99, 132, 0.7)',
      },
    ],
  };

  return (
    <Container className="startpage">
      <Link to={`/LeadsForAccountant`} style={{ textDecoration: 'none', color: '#0F7687' }}>
        <span style={{ fontWeight: 'bold' }}>Home</span>
      </Link>{' '}
      <KeyboardDoubleArrowRightIcon /> <span>Sales And Commissions Reports</span>
      <hr />
      <h3 className="mb-4 my-4">📆 Monthly Sales & Commission Report</h3>
      <Row xs={1} md={3} className="g-4">
        {AllData_Array.map((item, idx) => (
          <Col key={idx}>
            <Card className="shadow-sm h-100">
              <Card.Body>
                <Card.Title className="text-primary">{item.month}</Card.Title>
                <Card.Text>
                  <strong>💰 Sales:</strong> {item.totalUnitPrice.toLocaleString()} AED
                </Card.Text>
                <Card.Text>
                  <strong>📈 Commission:</strong> {item.totalCommission.toLocaleString()} AED
                </Card.Text>
                <Card.Text>
                  <strong>🧾 Deals:</strong> {item.count}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
      <hr className="my-5" />
      <h4 className="text-center mb-4">📊 Monthly Bar Chart</h4>
      {chartReady && <Bar data={chartData} />}
      <hr className="my-5" />
      <div className="my-4">
        <h5 className="text-success">
          🥇 <strong>Top Sales Month:</strong> {topSalesMonth.month} —{' '}
          {topSalesMonth.totalUnitPrice.toLocaleString()} AED
        </h5>
        <h5 className="text-primary">
          💰 <strong>Top Commission Month:</strong> {topCommissionMonth.month} —{' '}
          {topCommissionMonth.totalCommission.toLocaleString()} AED
        </h5>
      </div>
      <div style={{ marginBottom: '100px' }} />
    </Container>
  );
};
